module.exports = __webpack_public_path__ + "static/media/pending_empty.23dd0649.svg";